(($, duo) => {
  Drupal.behaviors.pagebanner = {

    attach: function(context, settings) {
      if (context !== document) {
        return;
      }

      this.init(context, settings);
    },

    init: function(context, settings) {
      const self = this;

      /* setup anchor links */
      /* ****************** */

      new duo.SmoothScroll({
        selector: '.js-page-banner-scroll-link',
        moveFocus: false
      });
    }

  };
})(jQuery, window.duo = window.duo || {});
